/*
 * echarts 图表块
 * Schema: 直接是 ECharts option JSON
 *
 * 用项目已有的 echarts ^5.6.0
 * 注：项目 Webpack 4 不支持 dynamic import，使用静态 import。
 */
import React, { useEffect, useMemo, useRef } from 'react'
import * as echarts from 'echarts'
import { tryParseJson } from './types'
import { useInvalidBlockWarning } from './useInvalidBlockWarning'
import './EChartsBlock.scss'

interface EChartsBlockProps {
  code: string
}

export const EChartsBlock: React.FC<EChartsBlockProps> = ({ code }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const chartRef = useRef<any>(null)
  // memo 化:tryParseJson 每次调用都返回新对象,不 memo 的话 useEffect 依赖
  // [option] 每次 render 都判定变化 → 图表反复 dispose+init,闪烁且丢交互态
  const option = useMemo(() => tryParseJson<any>(code), [code])

  useEffect(() => {
    if (!option || !containerRef.current) return

    if (chartRef.current) {
      chartRef.current.dispose()
    }
    chartRef.current = echarts.init(containerRef.current)
    chartRef.current.setOption(option)

    const handleResize = () => {
      if (chartRef.current) chartRef.current.resize()
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      if (chartRef.current) {
        chartRef.current.dispose()
        chartRef.current = null
      }
    }
  }, [option])

  // 流式中 JSON 未收齐时 silent 不渲染，避免闪"图表数据无效"（对齐 FileListBlock）；
  // 流式结束后仍无效 → useInvalidBlockWarning 会 console.warn 留排查线索
  const valid = !!option
  useInvalidBlockWarning('echarts', code, valid)
  if (!option) {
    return null
  }

  return (
    <div className="aiClerk-block-echarts">
      <div ref={containerRef} className="aiClerk-block-echarts__canvas" />
    </div>
  )
}
